import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';

// API endpoints
const API_LIST = '/p-crm-task-category';
const API_DETAIL = (id: number) => `/p-crm-task-category/${id}`;

export interface TaskCategory {
  id: number;
  tc_descr?: string;
}

export const useTaskCategorys = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<TaskCategory[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    taskCategorys: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const useTaskCategory = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<TaskCategory>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    taskCategory: data,
    isLoading,
    isError: error,
    mutate,
  };
};
